/**
 * 自动生成 router代码【模块名：文件分片上传记录表】
 * 生成日期：2026/10/20 16:50:17
 * 生成路径: src/router/file_upload.js
 * 生成人：超级管理员
 * 需要在文件 src/router/router.js 引入当前文件
 * import file_upload from './file_upload'
 // 路由详情
 const routes = [
 {
 path: '/',
 component: () => import('@/layouts/BasicLayout'),
 name: 'BasicLayout',
 meta: { title: '首页' },
 redirect: '/myNav',
 children: [
 ...
 file_upload,//文件分片上传记录表
 ]
 */

export default  {
    path: 'file_upload/list',
    name: 'file_upload',
    component: () => import('@/pages/file_upload/FileUploadList'),
    meta: { title: '分片上传记录' },
}
